'use client'

import { useState } from 'react'
import { Glossary } from '../jbda/glossary'
import { Question } from './faq-question'
import { LangCode } from '../i18n/lang-context'

export function FAQ({ questions, background2, glossary, langCode }: { questions: Question[], background2?: boolean, glossary?: Glossary, langCode: LangCode }) {

  return (
    <div className='w-full'>
      {questions.map((question, i) => (
        <Question
          key={i}
          index={i}
          question={question}
          background2={background2}
          glossary={glossary}
          langCode={langCode}
        />
      ))}
    </div>
  )
}
